import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-page-header',
  standalone: true,
  template: `
    <header class="cg-admin-page-header">
      <div class="cg-admin-page-header__desc">
        <ng-content select="[description]" />
      </div>
      <div class="cg-admin-page-header__actions">
        <ng-content select="[actions]" />
      </div>
    </header>
  `,
})
export class AdminPageHeaderComponent {}
